<section class="loginSection">
    <div class="login mt-5">
        <div class="">
            
            <div class="logo-container">
                <img  [src]="imageURL | async" alt="Active Image">
            </div>
            <div class="text-center mt-5 mb-3">
                <h6 class="forgot-password-msg">{{'forgot_password_msg' | translate}}</h6>
            </div>
            <form class="form" [formGroup]="loginForm">
                <div class="col-xs-12 col-sm-12 col-md-12 ">
                    <div class="form-group mb-3">
                        <label class="fw-bold" for="email">{{'Email_ID'|translate}}<span
                                class="text-danger"> *</span></label>
                        <input type="text" formControlName="username" placeholder="{{'Enter_Email_ID'|translate}}"
                            [ngClass]="{ 'is-invalid': submitted && control['username'].errors }" 
                            class="form-control">
                        <div *ngIf="control['username'].errors && submitted" class="small">
                            <div *ngIf="control['username'].errors['required']" class="text-danger letterspacing">
                                {{'user_email_is_required'|translate}} </div>
                            <div *ngIf="control['username'].errors['pattern']" class="text-danger letterspacing">
                                {{'INVALID_EMAIL'|translate}} </div>
                        </div>
                    </div>
                    <div class="text-center mt-3">
                        <button class="btn btnc btnc me-1" (click)="login()"><em class="fa fa-check-circle"></em> {{
                            'Submit' | translate }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>

</section>